module.exports = __webpack_public_path__ + "img/IMG_7201P.f11758c6.jpg";